import { rankItem } from '@tanstack/match-sorter-utils'
import { FilterFn } from '@tanstack/react-table'

/**
 * A custom fuzzy filter function for use with @tanstack/react-table.
 * This function ranks rows based on their match to a given filter value using @tanstack/match-sorter-utils.
 * Reference: https://tanstack.com/table/latest/docs/api/features/global-filtering
 *
 * @param {object} row - The row object from the table.
 * @param {string} columnId - The ID of the column to filter.
 * @param {string} value - The filter value to compare against.
 * @param {Function} addMeta - Function to add metadata to the filter process.
 * @returns {boolean} - Returns true if the item matches the filter criteria, otherwise false.
 */
const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
    // Rank the item
    const itemRank = rankItem(row.getValue(columnId), value)

    // Store the itemRank info
    addMeta({
        itemRank
    })

    // Return if the item should be filtered in/out
    return itemRank.passed
}

export default fuzzyFilter
